var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14.8788L3.44414 14.4754L3.4365 14.467L3.42854 14.4588L3 14.8788ZM4.2 16.2V16.8H4.8V16.2H4.2ZM8.4 17.3789L8.42108 16.7792L8.35776 17.9774L8.4 17.3789ZM9 9H8.4C8.4 9.15913 8.46322 9.31175 8.57574 9.42426L9 9ZM16.8 9C16.8 13.3079 13.3079 16.8 9 16.8V18C13.9705 18 18 13.9705 18 9H16.8ZM9 1.2C13.3079 1.2 16.8 4.69218 16.8 9H18C18 4.02943 13.9705 0 9 0V1.2ZM9 0C4.02943 0 0 4.02943 0 9H1.2C1.2 4.69218 4.69218 1.2 9 1.2V0ZM3.42854 14.4588C2.04936 13.0514 1.2 11.1255 1.2 9H0C0 11.452 0.981388 13.676 2.57146 15.2987L3.42854 14.4588ZM2.55586 15.2821L3.75586 16.6034L4.64414 15.7966L3.44414 14.4754L2.55586 15.2821ZM9 16.8C8.81237 16.8 8.62638 16.7934 8.44224 16.7804L8.35776 17.9774C8.56999 17.9924 8.78416 18 9 18V16.8ZM9.02108 16.8004L8.42108 16.7792L8.37892 17.9785L8.97892 17.9996L9.02108 16.8004ZM8.4 3.6V9H9.6V3.6H8.4ZM8.57574 9.42426L12.1757 13.0243L13.0243 12.1757L9.42426 8.57574L8.57574 9.42426ZM0 16.8H4.2V15.6H0V16.8ZM4.8 16.2V12H3.6V16.2H4.8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.5228a0ae43a6c49f1d1edee39c780198.svg";
export { ForwardRef as ReactComponent };